import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const mock = [
  {
    title: 'Protección de datos Personales - HABEAS DATA',
    description: `A través de la Ley 1581 de 2012 y el Decreto 1377 de 2013, se desarrolla el derecho constitucional que tienen todas las personas a conocer, suprimir, actualizar y rectificar todo tipo de datos personales recolectados, almacenados o que hayan sido objeto de tratamiento en bases de datos de hauscanner.com.

      hauscanner.com (como se conocerá en adelante), crea la siguiente política de privacidad y tratamiento de los datos que sean recolectados provenientes de personas, tanto naturales como jurídicas durante y después de la prestación del servicio de información prestado, con fines estrictamente relacionados con aspectos comerciales, garantizando el derecho de todos los intervinientes a conocer, actualizar y rectificar las informaciones que sobre ellos se hubiere recogido.

      De conformidad con la Ley 1581 de 2012 y el Decreto 1377 de 2013, autorización para continuar con el tratamiento de sus datos personales, impartiendo una autorización o negación de la misma, a través de los diferentes canales de atención al cliente que tiene la Entidad, como son:`,
  },
  {
    title: 'Nombre: SITE S.A.S.',
  },
  {
    title: 'Teléfono: +57 314 5410430',
  },
  {
    title: 'Correo electrónico: info@hauscanner.com',
  },
  {
    title: 'Encargado del tratamiento de datos:',
    description: `SITE S.A.S., se encargará de la recolección, almacenamiento, manejo, trasmisión, rectificación, actualización y protección de los datos provenientes de los usuarios de la plataforma, así como de terceros.`,
  },
];

const PrivacySection = ({ title, description }: any) => {
  return (
    <Box>
      <Typography
        variant={'h6'}
        gutterBottom
        sx={{
          fontWeight: 'medium',
        }}
      >
        {title}
      </Typography>
      <Typography component={'p'} color={'text.secondary'}>
        {description}
      </Typography>
    </Box>
  );
};

const Content = () => {
  return (
    <Box>
      {mock.map((item, i) => (
        <Box key={i} marginBottom={i < mock.length - 1 ? 4 : 0}>
          <PrivacySection {...item} />
        </Box>
      ))}
    </Box>
  );
};

export default Content;
